function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
export default function NeutralToggle({
  value,
  onChange,
  optionTrue,
  optionFalse,
  ...props
}) {
  const valueMap = {
    "1": true,
    "2": false
  };
  const mapValue = {
    [true]: "1",
    [false]: "2"
  };
  return /*#__PURE__*/React.createElement(ToggleButtonGroup, _extends({}, props, {
    type: "radio",
    name: "neutral",
    controlid: "neutralId",
    value: mapValue[value],
    onChange: v => onChange(valueMap[v])
  }), /*#__PURE__*/React.createElement(ToggleButton, {
    id: "neutral-1",
    variant: "outline-success",
    value: "1"
  }, optionTrue), /*#__PURE__*/React.createElement(ToggleButton, {
    id: "neutral-2",
    variant: "outline-danger",
    value: "2"
  }, optionFalse));
}